import { Route, Routes } from 'react-router-dom';
import './App.css';
import Header from './pages/Header';
import Footer from './pages/Footer';
import Blog from './pages/Blog';
import Testimonal from './pages/Testimonal';
import About from './pages/About';
import Service from './pages/Service';
import Angular from './pages/courses/Angular';
import Corejava from './pages/courses/Corejava';
import Javafullstack from './pages/courses/Javafullstack';
import Frontend from './pages/courses/Frontend';
import Flutter from './pages/courses/Flutter';
import Netwrok from './pages/courses/Netwrok';
import Photoshop from './pages/courses/Photoshop';
import Illustrator from './pages/courses/Illustrator';
import Testing from './pages/courses/Testing';
import Sql from './pages/courses/Sql';
import Contact from './pages/Contact';
import Phpfullstack from './pages/courses/Phpfullstack';
import Dotnet from './pages/courses/Dotnet';
import Digitalmarketing from './pages/courses/Digitalmarketing';
import Reactjs from './pages/courses/React';
import Nodejs from './pages/courses/Nodejs';
import Chip from './pages/courses/Chip';
import Python from './pages/courses/Python';
import Careers from './pages/careers';
import Team from './pages/Team';

function App() {
  return (
    <div>
      <Header/>
      <Routes>
      <Route path="/" element={<Team/>}/>
        <Route path="/about" element={<About/>}/>
        <Route path="/service" element={<Service/>}/>
        <Route path="/feedback" element={<Testimonal/>}/>
        <Route path="/angular" element={<Angular/>}/>
        <Route path="/corejava" element={<Corejava/>}/>
        <Route path="/javafullstack" element={<Javafullstack/>}/>
        <Route path="/python" element={<Python/>}/>
        <Route path="/frontend" element={<Frontend/>}/>
        <Route path="/flutter" element={<Flutter/>}/>
        <Route path="/hardware" element={<Netwrok/>}/>
        <Route path="/photoshop" element={<Photoshop/>}/>
        <Route path="/illustrator" element={<Illustrator/>}/>
        <Route path="/testing" element={<Testing/>}/>
        <Route path="/sqlserver" element={<Sql/>}/>
        <Route path="/contact" element={<Contact/>}/>
        <Route path="/php" element={<Phpfullstack/>}/>
        <Route path="/dotnet" element={<Dotnet/>}/>
        <Route path="/digitalmarketing" element={<Digitalmarketing/>}/>
        <Route path="/react" element={<Reactjs/>}/>
        <Route path="/node" element={<Nodejs/>}/>
        <Route path="/chiplevelservice" element={<Chip/>}/>
        <Route path="/careers" element={<Careers/>}/>
      </Routes>
      
      
      <Blog/>
      <Footer/>
    </div>
  );
}

export default App;
